import React from 'react';
import { ClipboardList, Award, CheckCircle } from 'lucide-react';

export const AssessmentModule: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-violet-100 text-violet-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Pearson Q-global & WPS Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Diagnostic Clinical Assessment</h2>
          <p className="text-xs text-slate-500">Sensory profile, CARS-2, Vineland-3 benchmarks, and clinical scoring</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-violet-50/50 border border-violet-200 rounded-xl space-y-2">
          <div className="text-xs font-bold text-violet-900">Sensory Profile 2 Score</div>
          <div className="text-2xl font-black text-violet-700">92 / 100</div>
          <div className="text-[10px] text-slate-500">Definite Difference: Auditory Processing</div>
        </div>

        <div className="p-4 bg-indigo-50/50 border border-indigo-200 rounded-xl space-y-2">
          <div className="text-xs font-bold text-indigo-900">Vineland-3 Adaptive Scale</div>
          <div className="text-2xl font-black text-indigo-700">88 Standard Score</div>
          <div className="text-[10px] text-slate-500">Moderate Strength: Daily Living Skills</div>
        </div>

        <div className="p-4 bg-emerald-50/50 border border-emerald-200 rounded-xl space-y-2">
          <div className="text-xs font-bold text-emerald-900">Diagnostic Status</div>
          <div className="text-sm font-bold text-emerald-700 mt-1">Evaluation Completed</div>
          <div className="text-[10px] text-slate-500">Next Review: Annual Re-evaluation 2027</div>
        </div>
      </div>
    </div>
  );
};
